<template>
  <div class="login">
    <a-descriptions layout="vertical">
      <a-descriptions-item label="代理商账号">{{sandbox.agent_phone}}</a-descriptions-item>
      <a-descriptions-item label="代理商密码">{{sandbox.agent_pwd}}</a-descriptions-item>
    </a-descriptions>
    <a-divider></a-divider>
    <a-descriptions :column="1">
      <a-descriptions-item label="应用名称">{{sandbox.app_name}}</a-descriptions-item>
      <a-descriptions-item label="应用包名">{{sandbox.app_package}}</a-descriptions-item>
      <a-descriptions-item label="APP ID">
        {{sandbox.app_id}}
        <a-icon
          v-if="!!sandbox.app_id"
          type="copy"
          v-clipboard:copy="sandbox.app_id"
          v-clipboard:success="onCopy"
        />
      </a-descriptions-item>
      <a-descriptions-item label="APP Secret">
        {{sandbox.app_secret}}
        <a-icon
          v-if="!!sandbox.app_secret"
          type="copy"
          v-clipboard:copy="sandbox.app_secret"
          v-clipboard:success="onCopy"
        />
      </a-descriptions-item>
      <a-descriptions-item label="应用描述">{{sandbox.app_desc}}</a-descriptions-item>
      <a-descriptions-item label="应用网址">{{sandbox.app_url}}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      size: "default",
    };
  },
  computed: mapState({
    sandbox: (state) => state.common.sandbox || {},
  }),
  mounted() {
    this.getSandbox();
  },
  methods: {
    ...mapActions("common", ["getSandbox"]),
    onCopy() {
      this.$message.success("复制成功");
    },
  },
};
</script>

<style lang="less">
</style>
